(ns rothko.layout.component
  (:require [clojure.spec.alpha :as s]
            [reagent.core :as r]
            [rothko.common :refer [merge-into]]
            [rothko.component.core :refer [defcomp]]
            [rothko.component.core :refer [ensure-props-and-children with-classes]]
            [rothko.component.spec :as comp-spec]))

(defn layout-item
  [hiccup appearance]
  (if (s/valid? ::comp-spec/hiccup hiccup)
    (let [{:keys [component props children] :as contents}
          (s/conform ::comp-spec/hiccup hiccup)]
      (s/assert ::comp-spec/props props)
      (s/unform ::comp-spec/hiccup
                {:component component
                 :props (merge-with into props
                                    {:class [:layout-item]}
                                    {:class (map #(str (name %) "-item") appearance)})
                 :children children}))))

(defcomp layout
  {:component-type ::layout}
  [{:keys [appearance class element style] :as props} & children]
  (into [(or element :div) {:class (concat class appearance [:layout])
                            :style style}]
        (map #(layout-item % appearance) children)))
